module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper",
    style: ({
      minHeight: _vm.minHeight + 'px'
    })
  }, [(_vm.data) ? _c('div', {
    staticClass: "_inner"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n            BMI检测结果\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h2', [_vm._v("\n                " + _vm._s(_vm.data.title) + "\n            ")]), _vm._v(" "), _vm._l((_vm.data.info), function(item) {
    return _c('div', {
      staticClass: "inner-box"
    }, [_c('h3', [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n                        目标值 ---- " + _vm._s(item.target || item.taget) + "\n                    ")]), _vm._v(" "), _c('li', [_vm._v("\n                        当前值 ---- "), _c('span', {
      class: ("value-status " + (item.is_normal===1 ? '' : 'alert'))
    }, [_vm._v(_vm._s(item.user_data) + " (" + _vm._s(item.is_normal === 1 ? '正常' : '异常') + ")")])])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h2', [_vm._v("健康点评")]), _vm._v(" "), _c('div', {
    staticClass: "inner-box"
  }, [_c('h3', [_vm._v("筛查建议：")]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.data.comment.advice) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "inner-box"
  }, [_c('h3', [_vm._v("控制目标：")]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.data.comment.goal) + "\n                ")])])])]) : _vm._e(), _vm._v(" "), _c('BottomBar', {
    attrs: {
      "index": 2
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../images/bmi.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-34b19f87!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/survey-result-detail.vue
// module id = 286
// module chunks = 1